import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const EMBLEM = "/emblem.png";

// Temporary placeholder avatar (by gender) shown until a real photo is uploaded.
export const avatarFor = (u = {}) => {
  const g = (u.gender || "").toLowerCase();
  if (g === "female") return "/avatars/female.jpg";
  if (g === "male") return "/avatars/male.jpg";
  return "/avatars/neutral.jpg";
};

const TOKEN_KEY = "rsp_session_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Extract a safe string message from an axios error (handles FastAPI 422 arrays).
export const apiError = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ") || fallback;
  if (d && typeof d.msg === "string") return d.msg;
  return fallback;
};

// True if a ship date is today or in the past.
export const hasShipped = (iso) => {
  if (!iso) return false;
  return Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000) <= 0;
};

// Display a stored ISO date as YYYY-MM-DD (dates are stored date-only, so slice avoids TZ shifts).
export const ymd = (iso) => {
  if (!iso) return "";
  const s = String(iso);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Build a viewable URL for images. Internal uploads come back as "/api/files/<path>"
// and require the session token as a query param.
export const mediaSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${BACKEND_URL}${url}${sep}token=${getToken() || ""}`;
};

export const api = axios.create({ baseURL: API, withCredentials: false });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
